import { render, staticRenderFns } from "./FaultiesIndicator.vue?vue&type=template&id=f01d4236&"
import script from "./FaultiesIndicator.vue?vue&type=script&lang=js&"
export * from "./FaultiesIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn,QAvatar,QSpinner,QIcon,QTooltip} from 'quasar'
component.options.components = Object.assign({QBtn,QAvatar,QSpinner,QIcon,QTooltip}, component.options.components || {})
